import React from 'react';
import PropTypes from 'prop-types';
import EntityAccordion from './EntityAccordion';

const propTypes = {
  groupedFields: PropTypes.object,
  basePath: PropTypes.string,
  refetch: PropTypes.func,
};

function DefaultFieldsView({ groupedFields, basePath }) {
  const entityTypes = [
    { key: 'instance', data: groupedFields.instance },
    { key: 'holdings', data: groupedFields.holding },
    { key: 'items', data: groupedFields.item },
  ];

  return entityTypes.map((entity) => {
    return (
      <EntityAccordion entity={entity} basePath={basePath} key={entity.key} />
    );
  });
}

DefaultFieldsView.propTypes = propTypes;

export default DefaultFieldsView;
